;(function($, window, document){
    window.Banner = Me.view.extend({
        options: {
        },


        initialize: function() {
            _.bindAll(this, 'closeBannerHandler');
            this.addEvents();
            $el = this.$el;

            var cookie = Cookies.get('bandeau')


            if(typeof cookie === 'undefined'){
                $el.removeClass('hide');
                Me.dispatch.emit('banner.changed', this);
            } else{

                $.ajax({
                    url: "/getBannerTime",
                    method: 'GET',
                    async: true,
                    success: function (result) {

                         var bannerTime = JSON.parse(result).bannerTime;

                         if (cookie < (bannerTime*1000)){
                             $el.removeClass('hide');
                             Cookies.remove('bandeau')
                         }else{
                             $('#site-ctn').removeClass('has-info-banner');
                             Me.dispatch.emit('banner.changed', this);
                         }
                    }
                });

            }
        },
        addEvents: function() {
            this.$('.close').on('click', this.closeBannerHandler);
        },
        closeBannerHandler: function(e){
            this.$el.css('display', 'none');
            var time = Date.now();
            Cookies.set('bandeau', time);

            $('#site-ctn').removeClass('has-info-banner');
            Me.dispatch.emit('banner.changed', this);
        }
    });
}(jQuery, window, document));
